import { render } from "./AppExpandTransition.vue?vue&type=template&id=49ec0a50&scoped=true&ts=true"
import script from "./AppExpandTransition.vue?vue&type=script&lang=ts"
export * from "./AppExpandTransition.vue?vue&type=script&lang=ts"

import "./AppExpandTransition.vue?vue&type=style&index=0&id=49ec0a50&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ec0a50"]])

export default __exports__